module.exports = __webpack_public_path__ + "media/images/countrysquared/dz-7ac368554e5e15d527b1c39e398d1466.svg";